import React, { useState } from 'react';
import { MenuIcon, XIcon, GlobeIcon, ChevronDownIcon } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  return <nav className="sticky top-0 z-50 bg-[#E87B5C] backdrop-blur-md shadow-sm" data-id="element-358">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-359">
        <div className="flex justify-between h-16 items-center" data-id="element-360">
          {/* Left side menu items */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-361">
            <a href="#features" className="text-white/90 hover:text-white transition-colors font-medium" data-id="element-362">
              Features
            </a>
            <a href="#how-it-works" className="text-white/90 hover:text-white transition-colors font-medium" data-id="element-363">
              How It Works
            </a>
            <a href="#faq" className="text-white/90 hover:text-white transition-colors font-medium" onClick={e => {
            e.preventDefault();
            setIsMenuOpen(false);
            const faqElement = document.getElementById('faq');
            if (faqElement) {
              faqElement.scrollIntoView({
                behavior: 'smooth'
              });
            }
          }} data-id="element-364">
              FAQ
            </a>
          </div>
          {/* Language Selector - stays on the right */}
          <div className="relative ml-auto" data-id="element-365">
            <button onClick={() => setIsLangMenuOpen(!isLangMenuOpen)} className="flex items-center text-white/90 hover:text-white transition-colors focus:outline-none" aria-label="Select language" data-id="element-366">
              <GlobeIcon className="h-5 w-5 mr-1" data-id="element-367" />
              <span className="hidden sm:inline-block mr-1 font-medium" data-id="element-368">
                English
              </span>
              <ChevronDownIcon className="h-4 w-4" data-id="element-369" />
            </button>
            {/* Language dropdown menu */}
            {isLangMenuOpen && <div className="absolute right-0 mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50" data-id="element-370">
                <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="language-menu" data-id="element-371">
                  <div className="px-4 py-2 text-sm text-[#E87B5C] bg-gray-100 font-medium" data-id="element-372">
                    English
                  </div>
                  <div className="px-4 py-3 text-sm text-gray-500 border-t border-gray-100" data-id="element-373">
                    Emigo in other languages coming soon!
                  </div>
                </div>
              </div>}
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-374">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-white hover:text-white/80 focus:outline-none" data-id="element-375">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-376" /> : <MenuIcon className="h-6 w-6" data-id="element-377" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-[#D16A4A] shadow-lg rounded-b-lg" data-id="element-378">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-379">
            <a href="#features" className="block px-3 py-2 text-white/90 hover:bg-[#E87B5C] hover:text-white rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-380">
              Features
            </a>
            <a href="#how-it-works" className="block px-3 py-2 text-white/90 hover:bg-[#E87B5C] hover:text-white rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-381">
              How It Works
            </a>
            <a href="#faq" className="block px-3 py-2 text-white/90 hover:bg-[#E87B5C] hover:text-white rounded-md font-medium" onClick={e => {
          e.preventDefault();
          setIsMenuOpen(false);
          const faqElement = document.getElementById('faq');
          if (faqElement) {
            faqElement.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-382">
              FAQ
            </a>
          </div>
        </div>}
    </nav>;
};
export default Navbar;